import React from 'react'

const componentPromise = import('./termsOfService' /* webpackChunkName: "termsOfServicePage"*/)

const Component = React.lazy(() => componentPromise)

export default Component